export default __webpack_public_path__ + "static/media/thumb.3735ca69.svg";